import React, { useState } from 'react';
import './styles/App.css';

// IMPORT PAGES
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import RailwayTunnels from './pages/RailwayTunnels';
import IrrigationTunnels from './pages/IrrigationTunnels';
import RoadTunnels from './pages/RoadTunnels';
import WaterSupplyWorks from './pages/WaterSupplyWorks';
import Bridges from './pages/Bridges';
import Highways from './pages/Highways';
import OngoingProjects from './pages/OngoingProjects';
import CompletedProjects from './pages/CompletedProjects';
import Facilities from './pages/Facilities';
import Achievements from './pages/Achievements';
import ContactUs from './pages/ContactUs';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  // NAVIGATION HANDLER
  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0); // Scroll to top when page changes
  };

  // RENDER PAGES BASED ON CURRENT PAGE
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={handleNavigate} />;
      
      case 'about-us':
        return <AboutUs onNavigate={handleNavigate} />;
      
      // BUSINESS VERTICALS
      case 'railway-tunnels':
        return <RailwayTunnels onNavigate={handleNavigate} />;
      case 'irrigation-tunnels':
        return <IrrigationTunnels onNavigate={handleNavigate} />;
      case 'road-tunnels':
        return <RoadTunnels onNavigate={handleNavigate} />;
      case 'water-supply':
        return <WaterSupplyWorks onNavigate={handleNavigate} />;
      case 'bridges':
        return <Bridges onNavigate={handleNavigate} />;
      case 'highways':
        return <Highways onNavigate={handleNavigate} />;
      
      // PROJECTS
      case 'ongoing-projects':
        return <OngoingProjects onNavigate={handleNavigate} />;
      case 'completed-projects':
        return <CompletedProjects onNavigate={handleNavigate} />;
      case 'facilities':
        return <Facilities onNavigate={handleNavigate} />;
      case 'achievements':
        return <Achievements onNavigate={handleNavigate} />;
      
      // CONTACT
      case 'contact-us':
        return <ContactUs onNavigate={handleNavigate} />;
      
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="App">
      {renderPage()}
    </div>
  );
}

export default App;